import { render, staticRenderFns } from "./EEvento.vue?vue&type=template&id=7ce5cff7&"
import script from "./EEvento.vue?vue&type=script&lang=js&"
export * from "./EEvento.vue?vue&type=script&lang=js&"
import style0 from "./EEvento.vue?vue&type=style&index=0&id=7ce5cff7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports